import { render, staticRenderFns } from "./listCategoriaDocumentos.vue?vue&type=template&id=3c18a8d2&scoped=true"
import script from "./listCategoriaDocumentos.ts?vue&type=script&lang=ts&external"
export * from "./listCategoriaDocumentos.ts?vue&type=script&lang=ts&external"
import style0 from "./listCategoriaDocumentos.vue?vue&type=style&index=0&id=3c18a8d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18a8d2",
  null
  
)

export default component.exports